import React from "react";
import { FaFilter } from "react-icons/fa";
import "../styles/home.css";

const FilterDrawer = ({
  isOpen,
  setIsOpen,
  categories,
  categoryFilter,
  setCategoryFilter,
  priceFilter,
  setPriceFilter
}) => {
  return (
    <>
      {/* FILTER BUTTON */}
      <button
        className="filter-button"
        onClick={() => setIsOpen(true)}
      >
        <FaFilter />
      </button>

      {/* OVERLAY */}
      {isOpen && (
        <div
          className="filter-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* FILTER DRAWER */}
      <div className={`filter-drawer ${isOpen ? "open" : ""}`}>

        <div className="filter-header">
          <h3>Filters</h3>
          <button onClick={() => setIsOpen(false)}>✕</button>
        </div>

        {/* CATEGORY FILTER */}
        <div className="filter-section">
          <h4>Category</h4>

          <select
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
            <option value="All">All Categories</option>

            {categories.map((cat, index) => (
              <option key={index} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        {/* PRICE FILTER */}
        <div className="filter-section">
          <h4>Price</h4>

          <select
            value={priceFilter}
            onChange={(e) => setPriceFilter(e.target.value)}
          >
            <option value="All">All Prices</option>
            <option value="low">Below ₹1000</option>
            <option value="mid">₹1000 - ₹5000</option>
            <option value="high">Above ₹5000</option>
          </select>
        </div>

      </div>
    </>
  );
};

export default FilterDrawer;